module.exports = __webpack_public_path__ + "static/media/HelveticaNeue-Bold.288d0807.ttf";